import { BaseGym } from '../types/Gym';

export const findMostExpensiveGym = (gyms: BaseGym[]): BaseGym => {
  return gyms.sort((gymA, gymB) => {
    const gymAMonthly = gymA.products.find((product) => product.type === 'monthly');
    const gymBMonthly = gymB.products.find((product) => product.type === 'monthly');
    return (gymAMonthly?.discount?.discounted_price || gymAMonthly?.price || 0) >
      (gymBMonthly?.discount?.discounted_price || gymBMonthly?.price || 0)
      ? -1
      : 1;
  })[0];
};

export const resolveGymImageUrl = (gymId: string, imageName: string, size?: string): string =>
  `${process.env.NEXT_PUBLIC_STATIC_DOMAIN}/gym_img/${size || '465x335'}/${gymId}/${imageName}`;
